export function downloadCsv(csvData, filename = 'download.csv') {
  const content = new window.Blob([csvData], { type: 'text/csv' })
  const link = document.createElement('a')
  link.setAttribute('href', window.URL.createObjectURL(content))
  link.setAttribute('download', filename)
  document.body.appendChild(link) // Required for FF
  link.click()
  document.body.removeChild(link)
}
